<app-login-container
    [hasBackNavigationButton]="hasBackNavigationButton"
    [subtitleI18NKey]="title">
    @if (isLoading()) {
        <app-loading />
    } @else if (isLoadingSSO()) {
        <app-loading [customMessage]="'connectionInProgress'" />
    } @else if (formGroup()) {
        <form
            class="flex flex-col items-center gap-y-6"
            [formGroup]="formGroup()"
            (ngSubmit)="submitForm()">
            @for (fieldName of fieldNames; track fieldName) {
                <mat-form-field
                    appearance="outline"
                    class="w-3/4"
                    subscriptSizing="dynamic">
                    @switch (fieldName) {
                        @case (SecurityFormField.PASSWORD) {
                            <mat-label>{{ 'password' | transloco: { COUNT: 1 } }}</mat-label>
                        }
                        @default {
                            <mat-label>{{ fieldName | transloco }}</mat-label>
                        }
                    }
                    <input
                        matInput
                        required
                        [formControlName]="fieldName"
                        [placeholder]="`placeholder${(fieldName | capitalize)}` | transloco"
                        [type]="getInputType(fieldName)" />
                    <fa-icon
                        class="ml-4 mr-2 text-on-surface"
                        matPrefix
                        [icon]="getPrefixIcon(fieldName)" />
                    @if (SecurityFormField.CONFIRM_PASSWORD === fieldName || SecurityFormField.PASSWORD === fieldName) {
                        <fa-icon
                            class="ml-2 mr-4 text-on-surface cursor-pointer"
                            matSuffix
                            [icon]="getSuffixIcon(fieldName)"
                            (click)="togglePasswordVisibility(fieldName)" />
                    }

                    @for (error of getControlErrors(fieldName); track error.key) {
                        <mat-error>{{ formService.getErrorMessage(error) }}</mat-error>
                    }
                </mat-form-field>
            }

            @if (
                formGroup().hasError(FormErrorEnum.MISMATCH) &&
                formGroup().controls[SecurityFormField.CONFIRM_PASSWORD].dirty
            ) {
                <mat-error class="font-semibold">{{ 'mismatchPasswordErrorMessage' | transloco }}</mat-error>
            }

            @if (
                organizationPasswordRules &&
                fieldNames.includes(SecurityFormField.CONFIRM_PASSWORD) &&
                formGroup().controls[SecurityFormField.PASSWORD]
            ) {
                <app-password-rules-verification
                    class="w-3/4"
                    [control]="formGroup().controls[SecurityFormField.PASSWORD]"
                    [rules]="organizationPasswordRules" />
            }

            <button
                class="w-3/4"
                color="primary"
                mat-flat-button
                type="submit"
                [disabled]="formGroup().invalid || isSubmitting">
                {{ actionLabel | transloco }}
            </button>
        </form>
    }

    @if (isLogin) {
        <button
            class="w-3/4 self-center"
            color="primary"
            mat-flat-button
            [routerLink]="['/', RoutePathEnum.SSO, RoutePathEnum.LOGIN]">
            {{ 'loginWithSSO' | transloco }}
        </button>
        <button
            class="w-3/4 self-center"
            mat-button
            [routerLink]="['/', RoutePathEnum.FORGOT_PASSWORD]">
            {{ 'forgottenPassword' | transloco }}
        </button>
    }

    <span class="divider"></span>
    <button
        mat-button
        (click)="isDontHaveAnAccountHelpDisplayed = !isDontHaveAnAccountHelpDisplayed">
        {{ 'dontHaveAnAccount' | transloco }}
    </button>

    @if (isDontHaveAnAccountHelpDisplayed) {
        <div
            class="flex w-[25rem]"
            outside-login-container>
            <div class="h-full w-[2px] mx-4 bg-outline-variant"></div>
            <div class="flex flex-col gap-y-6">
                <div class="flex gap-x-5 text-on-surface text-headline-6">
                    <fa-icon
                        class="cursor-pointer"
                        icon="xmark"
                        (click)="isDontHaveAnAccountHelpDisplayed = false" />
                    <p>{{ 'dontHaveAnAccount' | transloco }}</p>
                </div>
                <div class="flex flex-col gap-y-4">
                    <p class="text-headline-6 text-on-secondary-container">
                        {{ 'doesYourOrganisationHaveAccess' | transloco }}
                    </p>
                    <p class="text-body-1 text-on-background">
                        {{ 'contactYourManagerToCreateAccess' | transloco }}
                    </p>
                    <p class="text-body-1 text-on-background">
                        {{ 'toCreateUserAccess' | transloco }}
                    </p>
                    <span class="divider"></span>
                    <p class="text-headline-6 text-on-secondary-container">
                        {{ 'doesYourOrganisationNotHaveAccess' | transloco }}
                    </p>
                    <p class="text-body-1 text-on-background">
                        {{ 'contactUsForDemonstrationPlan' | transloco }}
                    </p>

                    <a
                        class="mx-auto w-fit"
                        color="primary"
                        href="mailto:contact@dotic.fr"
                        mat-flat-button>
                        {{ 'contactUs' | transloco }}
                    </a>
                </div>
            </div>
        </div>
    }
    <app-version class="self-center" />
</app-login-container>
